import { Input, Button, ButtonVariant } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { type UpdatePhoneStep, UpdatePhoneStepEnum, UpdatePhoneField } from '../../types/phone/phone-types'

const US_PHONE_FORMATTED_MAX_LENGTH = 14

export const ChangePhoneStep: FC<UpdatePhoneStep> = ({ ctaOnClick, isLoading }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()
  const { t } = useTranslation('features-settings')
  const STEP = UpdatePhoneStepEnum.CHANGE
  return (
    <div className="flex flex-col gap-4">
      <Input
        {...register(UpdatePhoneField.PHONE)}
        type="tel"
        maxLength={US_PHONE_FORMATTED_MAX_LENGTH}
        id={UpdatePhoneField.PHONE}
        testId={UpdatePhoneField.PHONE}
        label={t(`update_phone.${STEP}.input_label`)}
        required
        error={errors[UpdatePhoneField.PHONE]?.message as string}
        isPII
      />
      <Button variant={ButtonVariant.Primary} id="changePhoneContinue" onClick={ctaOnClick} isLoading={isLoading}>
        {t('settings.personal_info.change.continue')}
      </Button>
    </div>
  )
}
